const baseProps = {
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.8,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
  focusable: 'false',
  'aria-hidden': 'true',
};

function createIcon(elements) {
  return function IconComponent({ size = 20, className }) {
    return (
      <svg {...baseProps} className={className} width={size} height={size}>
        {elements.map((render, index) => render(index))}
      </svg>
    );
  };
}

export const Package = createIcon([
  index => <path key={`package-shell-${index}`} d="M21 16V8a2 2 0 0 0-1-1.73L12 2 3 6.27A2 2 0 0 0 2 8v8a2 2 0 0 0 1 1.73L12 22l9-4.27A2 2 0 0 0 22 16Z" />, 
  index => <path key={`package-left-${index}`} d="M2.3 6.7 12 12l9.7-5.3" />, 
  index => <line key={`package-center-${index}`} x1="12" y1="12" x2="12" y2="22" />,
]);

export const FileText = createIcon([
  index => <path key={`file-body-${index}`} d="M14 2H8a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V8Z" />, 
  index => <polyline key={`file-fold-${index}`} points="14 2 14 8 20 8" />, 
  index => <line key={`file-line1-${index}`} x1="9" y1="13" x2="15" y2="13" />, 
  index => <line key={`file-line2-${index}`} x1="9" y1="17" x2="15" y2="17" />,
]);

export const Tags = createIcon([
  index => <path key={`tags-body-${index}`} d="M7 3h5l9 9-6 6-9-9Z" />, 
  index => <path key={`tags-tail-${index}`} d="M7 3H4v3l3 3" />, 
  index => <circle key={`tags-hole-${index}`} cx="9.5" cy="7.5" r="1.5" />,
]);

export const Layers = createIcon([
  index => <polygon key={`layers-top-${index}`} points="12 3 3.5 7.5 12 12 20.5 7.5" />, 
  index => <polygon key={`layers-mid-${index}`} points="3.5 12 12 16.5 20.5 12" />, 
  index => <polygon key={`layers-bottom-${index}`} points="3.5 16.5 12 21 20.5 16.5" />,
]);

export const Map = createIcon([
  index => <polyline key={`map-outline-${index}`} points="3 6 3 21 9 18 15 21 21 18 21 3 15 6 9 3 3 6" />, 
  index => <line key={`map-fold1-${index}`} x1="9" y1="3" x2="9" y2="18" />, 
  index => <line key={`map-fold2-${index}`} x1="15" y1="6" x2="15" y2="21" />,
]);

export const Truck = createIcon([
  index => <rect key={`truck-cab-${index}`} x="1.5" y="11" width="13" height="7" rx="1.5" />, 
  index => <path key={`truck-box-${index}`} d="M14.5 13h4.2a1 1 0 0 1 .9.56l2.4 4.44v1" />, 
  index => <circle key={`truck-wheel1-${index}`} cx="6" cy="19" r="2" />, 
  index => <circle key={`truck-wheel2-${index}`} cx="17" cy="19" r="2" />, 
  index => <line key={`truck-line-${index}`} x1="14.5" y1="16" x2="21" y2="16" />,
]);

export const ClipboardList = createIcon([
  index => <rect key={`clipboard-board-${index}`} x="5" y="4" width="14" height="17" rx="2" />, 
  index => <path key={`clipboard-top-${index}`} d="M9 3.5h6" />, 
  index => <path key={`clipboard-clip-${index}`} d="M10 2h4a1 1 0 0 1 1 1v1H9V3a1 1 0 0 1 1-1Z" />, 
  index => <line key={`clipboard-row1-${index}`} x1="9" y1="11" x2="15" y2="11" />, 
  index => <line key={`clipboard-row2-${index}`} x1="9" y1="16" x2="15" y2="16" />, 
  index => <circle key={`clipboard-dot1-${index}`} cx="7" cy="11" r="0.8" />, 
  index => <circle key={`clipboard-dot2-${index}`} cx="7" cy="16" r="0.8" />,
]);

export const Users = createIcon([
  index => <path key={`users-main-${index}`} d="M17 21v-1.5a4 4 0 0 0-4-4h-2a4 4 0 0 0-4 4V21" />, 
  index => <circle key={`users-head1-${index}`} cx="12" cy="8" r="3" />, 
  index => <path key={`users-secondary-${index}`} d="M22 21v-1a4 4 0 0 0-3-3.87" />, 
  index => <path key={`users-tertiary-${index}`} d="M5 16.13A4 4 0 0 0 2 20v1" />, 
  index => <circle key={`users-head2-${index}`} cx="19" cy="5" r="2.5" />, 
  index => <circle key={`users-head3-${index}`} cx="5" cy="5" r="2.5" />,
]);

export const Settings = createIcon([
  index => <circle key={`settings-center-${index}`} cx="12" cy="12" r="3" />, 
  index => (
    <path
      key={`settings-gear-${index}`}
      d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09a1.65 1.65 0 0 0-1-1.51 1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09a1.65 1.65 0 0 0 1.51-1 1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06a1.65 1.65 0 0 0 1.82.33h.02A1.65 1.65 0 0 0 9 4.09V4a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51h.02a1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82v.02a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1Z"
    />
  ),
]);

export const Bell = createIcon([
  index => <path key={`bell-body-${index}`} d="M18 16.5V11a6 6 0 1 0-12 0v5.5l-1.5 2H19.5Z" />, 
  index => <path key={`bell-clapper-${index}`} d="M13.73 21a2 2 0 0 1-3.46 0" />,
]);

export const Sun = createIcon([
  index => <circle key={`sun-core-${index}`} cx="12" cy="12" r="4" />, 
  index => <line key={`sun-r1-${index}`} x1="12" y1="2" x2="12" y2="5" />, 
  index => <line key={`sun-r2-${index}`} x1="12" y1="19" x2="12" y2="22" />, 
  index => <line key={`sun-r3-${index}`} x1="4.22" y1="4.22" x2="6.34" y2="6.34" />, 
  index => <line key={`sun-r4-${index}`} x1="17.66" y1="17.66" x2="19.78" y2="19.78" />, 
  index => <line key={`sun-r5-${index}`} x1="2" y1="12" x2="5" y2="12" />, 
  index => <line key={`sun-r6-${index}`} x1="19" y1="12" x2="22" y2="12" />, 
  index => <line key={`sun-r7-${index}`} x1="4.22" y1="19.78" x2="6.34" y2="17.66" />, 
  index => <line key={`sun-r8-${index}`} x1="17.66" y1="6.34" x2="19.78" y2="4.22" />,
]);

export const Moon = createIcon([
  index => <path key={`moon-body-${index}`} d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79Z" />,
]);

export const Search = createIcon([
  index => <circle key={`search-lens-${index}`} cx="11" cy="11" r="6" />, 
  index => <line key={`search-handle-${index}`} x1="20" y1="20" x2="16.5" y2="16.5" />,
]);

export const ChevronDown = createIcon([
  index => <polyline key={`chevron-down-${index}`} points="6 9 12 15 18 9" />,
]);

export const ChevronRight = createIcon([
  index => <polyline key={`chevron-right-${index}`} points="9 6 15 12 9 18" />,
]);
export const MapPin = createIcon([
  index => <path key={`mappin-area-${index}`} d="M21 10c0 6-9 12-9 12s-9-6-9-12a9 9 0 1 1 18 0z" />,
  index => <circle key={`mappin-dot-${index}`} cx="12" cy="10" r="3" />,
]);
export const ChevronLeft = createIcon([
  index => <polyline key={`chevron-left-${index}`} points="15 6 9 12 15 18" />,
]);

export const Menu = createIcon([
  index => <line key={`menu-top-${index}`} x1="4" y1="6" x2="20" y2="6" />,
  index => <line key={`menu-mid-${index}`} x1="4" y1="12" x2="20" y2="12" />,
  index => <line key={`menu-bot-${index}`} x1="4" y1="18" x2="20" y2="18" />,
]);

export const UserCircle = createIcon([
  index => <circle key={`user-circle-outer-${index}`} cx="12" cy="12" r="10" />,
  index => <circle key={`user-circle-head-${index}`} cx="12" cy="10" r="3.2" />,
  index => <path key={`user-circle-body-${index}`} d="M7.5 18.5a5 5 0 0 1 9 0" />,
]);
export const User = createIcon([
  index => <path key={`user-body-${index}`} d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2" />,
  index => <circle key={`user-head-${index}`} cx="12" cy="7" r="4" />,
]);

export const TrendingUp = createIcon([
  index => <polyline key={`trending-line-${index}`} points="22 7 13.5 15.5 8.5 10.5 2 17" />,
  index => <polyline key={`trending-arrow-${index}`} points="16 7 22 7 22 13" />,
]);
export const X = createIcon([
  index => <line key={`x-line1-${index}`} x1="18" y1="6" x2="6" y2="18" />,
  index => <line key={`x-line2-${index}`} x1="6" y1="6" x2="18" y2="18" />,
]);

export const Save = createIcon([
  index => <path key={`save-body-${index}`} d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z" />,
  index => <polyline key={`save-flap-${index}`} points="17 21 17 13 7 13 7 21" />,
  index => <polyline key={`save-tab-${index}`} points="7 3 7 8 15 8" />,
]);
export const DollarSign = createIcon([
  index => <line key={`dollar-line-${index}`} x1="12" y1="2" x2="12" y2="22" />,
  index => <path key={`dollar-s-${index}`} d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" />,
]);
export const Building2 = createIcon([
  index => <rect key={`building-base-${index}`} x="4" y="3" width="16" height="18" rx="2" />,
  index => <path key={`building-roof-${index}`} d="M9 21V3" />,
  index => <path key={`building-door-${index}`} d="M15 21V3" />,
  index => <line key={`building-row1-${index}`} x1="7" y1="7" x2="9" y2="7" />,
  index => <line key={`building-row2-${index}`} x1="7" y1="11" x2="9" y2="11" />,
  index => <line key={`building-row3-${index}`} x1="7" y1="15" x2="9" y2="15" />,
  index => <line key={`building-row4-${index}`} x1="15" y1="7" x2="17" y2="7" />,
  index => <line key={`building-row5-${index}`} x1="15" y1="11" x2="17" y2="11" />,
  index => <line key={`building-row6-${index}`} x1="15" y1="15" x2="17" y2="15" />,
]);

export const Phone = createIcon([
  index => (
    <path
      key={`phone-body-${index}`}
      d="M6.5 4.5 9 4a2 2 0 0 1 2.3 1.5l.5 2A2 2 0 0 1 10 9l.6 1.2a13 13 0 0 0 3.2 3.2L15 14a2 2 0 0 1 1.5-1.8l2 .5A2 2 0 0 1 20 15v2.3a2 2 0 0 1-2 2 14.5 14.5 0 0 1-13-13 2 2 0 0 1 1.5-1.8Z"
    />
  ),
]);

export const Mail = createIcon([
  index => <rect key={`mail-body-${index}`} x="3" y="5" width="18" height="14" rx="2" />,
  index => <polyline key={`mail-flap-${index}`} points="3 7 12 13 21 7" />,
]);

export const Coins = createIcon([
  index => <ellipse key={`coins-front-${index}`} cx="12" cy="6" rx="7" ry="3" />,
  index => <path key={`coins-side-${index}`} d="M5 10c0 1.66 3.13 3 7 3s7-1.34 7-3" />,
  index => <path key={`coins-mid-${index}`} d="M5 14c0 1.66 3.13 3 7 3s7-1.34 7-3" />,
  index => <path key={`coins-top-${index}`} d="M5 6v10" />,
  index => <path key={`coins-top2-${index}`} d="M19 6v10" />,
]);

export const AlertTriangle = createIcon([
  index => <path key={`alert-triangle-body-${index}`} d="m10.3 3.3-8 14A1 1 0 0 0 3.2 19H20.8a1 1 0 0 0 .9-1.7l-8-14a1 1 0 0 0-1.7 0Z" />,
  index => <line key={`alert-triangle-line-${index}`} x1="12" y1="9" x2="12" y2="13" />,
  index => <circle key={`alert-triangle-dot-${index}`} cx="12" cy="16.5" r="0.8" />,
]);

export const CheckCircle = createIcon([
  index => <circle key={`check-circle-body-${index}`} cx="12" cy="12" r="10" />,
  index => <polyline key={`check-circle-mark-${index}`} points="8.5 12 11 14.5 15.5 9.5" />,
]);

export const XCircle = createIcon([
  index => <circle key={`x-circle-body-${index}`} cx="12" cy="12" r="10" />,
  index => <line key={`x-circle-line1-${index}`} x1="9" y1="9" x2="15" y2="15" />,
  index => <line key={`x-circle-line2-${index}`} x1="15" y1="9" x2="9" y2="15" />,
]);

export const Loader = createIcon([
  index => <line key={`loader-line1-${index}`} x1="12" y1="2" x2="12" y2="6" />,
  index => <line key={`loader-line2-${index}`} x1="12" y1="18" x2="12" y2="22" />,
  index => <line key={`loader-line3-${index}`} x1="4.93" y1="4.93" x2="7.76" y2="7.76" />,
  index => <line key={`loader-line4-${index}`} x1="16.24" y1="16.24" x2="19.07" y2="19.07" />,
  index => <line key={`loader-line5-${index}`} x1="2" y1="12" x2="6" y2="12" />,
  index => <line key={`loader-line6-${index}`} x1="18" y1="12" x2="22" y2="12" />,
  index => <line key={`loader-line7-${index}`} x1="4.93" y1="19.07" x2="7.76" y2="16.24" />,
  index => <line key={`loader-line8-${index}`} x1="16.24" y1="7.76" x2="19.07" y2="4.93" />,
]);
